import { cn } from '@elara/client-core/lib/utils';

import { Logo } from '#ui';

/**
 * The centred AI trip summary between the itinerary hero and the overview. Shows a skeleton while
 * the summary is being generated; renders nothing inside when there is no summary yet.
 */
export function ItinerarySummarySection({ summary, isLoading }: { summary?: string; isLoading?: boolean }) {
  return (
    <div data-print="summary" className="flex flex-col gap-12 items-center border-b py-24 md:py-50 bg-background-secondary">
      <Logo variant="symbol" width={40} height={40} />
      <div className={cn('w-full max-w-prose mx-auto px-4 md:px-8')}>
        {isLoading && !summary ? (
          <div className="space-y-2 mb-6">
            <div className="h-6 w-full rounded bg-camel-200 animate-pulse" />
            <div className="h-6 w-full rounded bg-camel-200 animate-pulse" />
            <div className="h-6 w-full max-w-[400px] mx-auto rounded bg-camel-200 animate-pulse" />
          </div>
        ) : (
          <div className="md:text-lg leading-normal text-center text-pretty">{summary}</div>
        )}
      </div>
      <hr className="w-20 mx-auto border-accent/50" />
    </div>
  );
}
